import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import styles from './document-signature-container.module.scss';
import { LoaderCube } from '@greenkub-fronts/shared/ui';
import { AppDispatch, RootState } from '@greenkub-fronts/shared/interface';
import {
  closeModalSignature,
  onValidateSign,
  setSignature,
} from '@greenkub-fronts/domain/signature';
import HtmlBodyLandingPageFeature
  from '../../../feature/html-body-landing-page-feature/html-body-landing-page-feature';
import PdfBodyLandingPageFeature
  from '../../../feature/pdf-body-landing-page-feature/pdf-body-landing-page-feature';
import { Button, Modal } from 'antd';

export function DocumentSignatureContainer () {
  const {
    isSignature,
    signature,
    fromExisting,
    toGenerate,
    isSigningDoc,
    modalIsOpen,
  } = useSelector((state: RootState) => state.signature);

  const dispatch = useDispatch<AppDispatch>();

  return (
    <div
      className={cx(
        styles['LandingPage'],
        fromExisting && styles['fromExisting'],
      )}
    >
      <LoaderCube isLoading={isSigningDoc} />
      {toGenerate && <HtmlBodyLandingPageFeature />}
      {fromExisting && <PdfBodyLandingPageFeature />}
      {isSignature && (
        <Modal
          open={modalIsOpen}
          width={500}
          onCancel={() => dispatch(closeModalSignature({}))}
          title={'Signature'}
          footer={[
            <Button
              key="document-signature-validate"
              type={'primary'}
              onClick={() => dispatch(onValidateSign({}))}
            >
              Apposer la signature
            </Button>,
          ]}
        >
          <div className={styles['LandingPage-sign-form']}>
            <input
              className={styles['LandingPage-signed']}
              type="text"
              maxLength={32}
              value={signature}
              onChange={(e) => {
                dispatch(setSignature({ signature: e.currentTarget.value }));
              }}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}
